<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
export default {
  name: 'Equipment',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          dateFrom: null,
          dateTo: null,
          academicYear: null,
        },
        collections: {
          academicYears: [],
          centers: [],
          municipalities: [],
          schools: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de Equipos',
        icon: 'fa-solid fa-list font-22 ',
        routes: ['Inicio', 'Asistencia Tecnológica', 'Informe de Equipos'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'status',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Estatus',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.statuses,
          value: this.model.search.filters.status,
        },
        {
          name: 'caat',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CAAT',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.caats,
          value: this.model.search.filters.caat,
        },
        {
          name: 'referralType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Referido',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.referralTypes,
          value: this.model.search.filters.referralType,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipio',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipality,
          onChanged: this.onChangedMunicipality,
          disabled: this.model.search.collections.municipalities <= 1,
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Escuela',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.schools,
          value: this.model.search.filters.school,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getReferralTypes() {
      const { data } = await referralAndEquipmentsservice.getReferralTypes();
      this.model.search.collections.referralTypes = data;
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process(
          this.model.search.filters.dateFrom,
          this.model.search.filters.dateTo
        );
      }
    },
    async getInitialFilters() {
      await this.getReferralTypes();
      await this.getStatuses();
      await this.getCaats();
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getCurrentYearAcademicYears()
      ).data;
    },
    async getStatuses() {
      const { data } = await referralAndEquipmentsservice.getStatuses();
      this.model.search.collections.statuses = data;
    },
    async onChangeAcademicYear() {
      if (this.model.search.filters.academicYear == null) {
        this.model.search.collections.municipalities = [];
        this.model.search.filters.municipality = null;
      } else {
        await this.getMunicipalities();
      }
    },
    async onChangedMunicipality() {
      if (this.model.search.filters.municipality == null) {
        this.model.search.collections.schools = [];
        this.model.search.filters.school = null;
      } else {
        await this.getSchools();
      }
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
      }).then(
        (res) => (this.model.search.collections.municipalities = res.data)
      );
    },
    async getCaats() {
      const { data } = await referralAndEquipmentsservice.getCaats();
      this.model.search.collections.caats = data;
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear.id,
        municipalityId: this.model.search.filters.municipality?.id,
      }).then((res) => (this.model.search.collections.schools = res.data));
    },
    async process(dateFrom, dateTo) {
      if (dateFrom > dateTo) {
        this.ShowToast(
          'Atención',
          'La Fecha Hasta no puede ser menor a la Fecha Desde.',
          'error'
        );
        return;
      }

      await ReportServices.getReport('equipmentreport', {
        academicYearId: this.model.search.filters.academicYear?.id,
        caatId: this.model.search.filters.caat?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        statusId: this.model.search.filters.status?.id,
        schoolId: this.model.search.filters.school?.id,
        referralTypeId: this.model.search.filters.referralType?.id,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>

<style lang="scss" scoped></style>
